import React, { Component, Fragment } from "react";
import image from "../../logo.png";
import "./Forgot.css";
import { toEnglishNumber } from "../../classes/utils";
import withRouter from "../withRouter/withRouter";

class Forgot extends Component {
    newPass;

    constructor(props) {
        super(props);
    }
    componentDidMount() {
        let { mobile, code } = this.props.router.params;

        if (!mobile || !code) {
            this.props.router.navigate("/");
        }
    }

    render() {
        return (
            <div className='ForgotComponent'>
                <div className='verify'>
                    رمز عبور جدید
                    <input
                        type='tel'
                        onChange={(ev) => {
                            this.newPass =
                                ev.target.validity.valid && ev.target.value;
                        }}
                        minLength={6}
                        required
                    />
                    <button
                        className='btn info'
                        onClick={(ev) => {
                            let { mobile, code } = this.props.router.params;

                            if (!this.newPass) return;
                            this.props.connection
                                .change_pass(mobile, code, this.newPass)
                                .then((res) => {
                                    alert("رمز عبور با موفقیت تغیر کرد");
                                    this.props.router.navigate("/register");
                                })
                                .catch((err) => {
                                    alert("کد یا شماره موبایل اشتباه است");
                                    this.props.router.navigate("/");
                                });
                        }}
                    >
                        تغیر رمز عبور
                    </button>
                    <button
                        onClick={(ev) => this.props.router.navigate("/")}
                        className='btn danger'
                    >
                        انصراف
                    </button>
                </div>
            </div>
        );
    }
}

export default withRouter(Forgot);
